import React from 'react';
import { Phone, CheckCircle, Award, Wrench } from 'lucide-react';
export function TrailerRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7305">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7306">
        <div className="container mx-auto px-4" data-id="element-7307">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7308">
            Trailer Repair
          </h1>
          <p className="text-2xl text-gray-100 text-center" data-id="element-7309">
            Our Certified and Licensed Mechanics Ensure Safety and Reliability
            of Trailer Repairs
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7310">
        <div className="max-w-4xl mx-auto" data-id="element-7311">
          {/* Certified Mechanics Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7312">
            <div className="flex items-start mb-6" data-id="element-7313">
              <Award className="text-[#B1050B] mr-4 flex-shrink-0 mt-1" size={48} data-id="element-7314" />
              <div data-id="element-7315">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-7316">
                  Certified & Licensed Professionals
                </h2>
                <p className="text-lg text-gray-700 mb-4" data-id="element-7317">
                  Unlike many trailer mechanics in the area, we employ certified
                  and licensed mechanics to diagnose and repair your trailer.
                  Need frame repairs on your trailer? Our certified welder is
                  well qualified to make the repairs your trailer requires. You
                  don't need the headache of a poor trailer repair leaving you
                  stranded or worse.
                </p>
              </div>
            </div>

            <div className="bg-red-50 border-2 border-[#B1050B] rounded-lg p-6 text-center" data-id="element-7318">
              <p className="text-2xl font-bold text-[#B1050B] mb-2" data-id="element-7319">Call Now</p>
              <a href="tel:2484788382" className="text-4xl font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7320">
                248-478-8382
              </a>
            </div>
          </div>

          {/* Trailer Types */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7321">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7322">
              Trailers We Service
            </h2>

            <p className="text-lg text-gray-700 text-center mb-6" data-id="element-7323">
              We repair RV Trailers, Horse Trailers, Dog Trailers, Aluminum
              Trailers, Steel Trailers, Goose Neck Trailers, 5th Wheel Trailers,
              Bumper Trailers... We also repair semi tractor trailers.
            </p>

            <div className="grid md:grid-cols-3 gap-3" data-id="element-7324">
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7325">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7326" />
                <span className="text-gray-700" data-id="element-7327">RV Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7328">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7329" />
                <span className="text-gray-700" data-id="element-7330">Horse Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7331">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7332" />
                <span className="text-gray-700" data-id="element-7333">Dog Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7334">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7335" />
                <span className="text-gray-700" data-id="element-7336">Aluminum Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7337">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7338" />
                <span className="text-gray-700" data-id="element-7339">Steel Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7340">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7341" />
                <span className="text-gray-700" data-id="element-7342">Goose Neck Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7343">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7344" />
                <span className="text-gray-700" data-id="element-7345">5th Wheel Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7346">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7347" />
                <span className="text-gray-700" data-id="element-7348">Bumper Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7349">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7350" />
                <span className="text-gray-700" data-id="element-7351">Semi Tractor Trailers</span>
              </div>
            </div>
          </div>

          {/* Specialized Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7352">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7353">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-7354" />
              We Specialize in All Trailer Repairs
            </h2>

            <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-7355">
              General Inspection, Maintenance and Part Replacement - including:
            </p>

            <div className="grid md:grid-cols-2 gap-3 mb-6" data-id="element-7356">
              <div className="flex items-start" data-id="element-7357">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7358" />
                <span className="text-gray-700" data-id="element-7359">Frames</span>
              </div>
              <div className="flex items-start" data-id="element-7360">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7361" />
                <span className="text-gray-700" data-id="element-7362">Axles</span>
              </div>
              <div className="flex items-start" data-id="element-7363">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7364" />
                <span className="text-gray-700" data-id="element-7365">Bearings</span>
              </div>
              <div className="flex items-start" data-id="element-7366">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7367" />
                <span className="text-gray-700" data-id="element-7368">Axle Bearing Repack</span>
              </div>
              <div className="flex items-start" data-id="element-7369">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7370" />
                <span className="text-gray-700" data-id="element-7371">Couplers</span>
              </div>
              <div className="flex items-start" data-id="element-7372">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7373" />
                <span className="text-gray-700" data-id="element-7374">Tongue jacks</span>
              </div>
              <div className="flex items-start" data-id="element-7375">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7376" />
                <span className="text-gray-700" data-id="element-7377">Hubs</span>
              </div>
              <div className="flex items-start" data-id="element-7378">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7379" />
                <span className="text-gray-700" data-id="element-7380">Runners</span>
              </div>
              <div className="flex items-start" data-id="element-7381">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7382" />
                <span className="text-gray-700" data-id="element-7383">Rollers</span>
              </div>
              <div className="flex items-start" data-id="element-7384">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7385" />
                <span className="text-gray-700" data-id="element-7386">Winches</span>
              </div>
              <div className="flex items-start" data-id="element-7387">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7388" />
                <span className="text-gray-700" data-id="element-7389">Lights</span>
              </div>
              <div className="flex items-start" data-id="element-7390">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7391" />
                <span className="text-gray-700" data-id="element-7392">Brakes</span>
              </div>
              <div className="flex items-start" data-id="element-7393">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7394" />
                <span className="text-gray-700" data-id="element-7395">Tires</span>
              </div>
              <div className="flex items-start" data-id="element-7396">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7397" />
                <span className="text-gray-700" data-id="element-7398">Tire Inspections</span>
              </div>
              <div className="flex items-start" data-id="element-7399">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7400" />
                <span className="text-gray-700" data-id="element-7401">
                  Electrical System Inspection
                </span>
              </div>
              <div className="flex items-start" data-id="element-7402">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7403" />
                <span className="text-gray-700" data-id="element-7404">Brake System Inspection</span>
              </div>
            </div>

            <div className="text-center" data-id="element-7405">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/trailers.gif" alt="Trailer repair services" className="mx-auto" data-id="element-7406" />
            </div>
          </div>

          {/* Hitches & Additional Services */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7407">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-7408">
              Hitches & Additional Services
            </h2>

            <div className="space-y-6" data-id="element-7409">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7410">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7411">
                  Hitch Services
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7412">
                  <div className="flex items-start" data-id="element-7413">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7414" />
                    <span className="text-gray-700" data-id="element-7415">5th Wheel Hitches</span>
                  </div>
                  <div className="flex items-start" data-id="element-7416">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7417" />
                    <span className="text-gray-700" data-id="element-7418">Class I-V Hitches</span>
                  </div>
                  <div className="flex items-start" data-id="element-7419">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7420" />
                    <span className="text-gray-700" data-id="element-7421">
                      Weight Distribution Hitches
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-7422">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7423">
                  All Types of Trailers
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7424">
                  <div className="flex items-start" data-id="element-7425">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7426" />
                    <span className="text-gray-700" data-id="element-7427">Cargo</span>
                  </div>
                  <div className="flex items-start" data-id="element-7428">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7429" />
                    <span className="text-gray-700" data-id="element-7430">Utility</span>
                  </div>
                  <div className="flex items-start" data-id="element-7431">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7432" />
                    <span className="text-gray-700" data-id="element-7433">Dump</span>
                  </div>
                  <div className="flex items-start" data-id="element-7434">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7435" />
                    <span className="text-gray-700" data-id="element-7436">Travel</span>
                  </div>
                  <div className="flex items-start" data-id="element-7437">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7438" />
                    <span className="text-gray-700" data-id="element-7439">5 wheel</span>
                  </div>
                  <div className="flex items-start" data-id="element-7440">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7441" />
                    <span className="text-gray-700" data-id="element-7442">Gooseneck</span>
                  </div>
                  <div className="flex items-start" data-id="element-7443">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7444" />
                    <span className="text-gray-700" data-id="element-7445">Boat</span>
                  </div>
                </div>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-7446">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7447">
                  Brake & Electrical Services
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7448">
                  <div className="flex items-start" data-id="element-7449">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7450" />
                    <span className="text-gray-700" data-id="element-7451">
                      Electric Brake Controls
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-7452">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7453" />
                    <span className="text-gray-700" data-id="element-7454">Electric Brake Repair</span>
                  </div>
                  <div className="flex items-start" data-id="element-7455">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7456" />
                    <span className="text-gray-700" data-id="element-7457">Electrical Repair</span>
                  </div>
                  <div className="flex items-start" data-id="element-7458">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7459" />
                    <span className="text-gray-700" data-id="element-7460">Surge Brake</span>
                  </div>
                  <div className="flex items-start" data-id="element-7461">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7462" />
                    <span className="text-gray-700" data-id="element-7463">Disc Brake Conversion</span>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-7464">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7465">
                  Performance & Additional Services
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7466">
                  <div className="flex items-start" data-id="element-7467">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7468" />
                    <span className="text-gray-700" data-id="element-7469">Air Bags</span>
                  </div>
                  <div className="flex items-start" data-id="element-7470">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7471" />
                    <span className="text-gray-700" data-id="element-7472">Tow Performance</span>
                  </div>
                  <div className="flex items-start" data-id="element-7473">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7474" />
                    <span className="text-gray-700" data-id="element-7475">Fuel Economy</span>
                  </div>
                  <div className="flex items-start" data-id="element-7476">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7477" />
                    <span className="text-gray-700" data-id="element-7478">Sales & Service</span>
                  </div>
                  <div className="flex items-start" data-id="element-7479">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7480" />
                    <span className="text-gray-700" data-id="element-7481">Rewiring</span>
                  </div>
                  <div className="flex items-start" data-id="element-7482">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7483" />
                    <span className="text-gray-700" data-id="element-7484">Check Suspension</span>
                  </div>
                  <div className="flex items-start" data-id="element-7485">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7486" />
                    <span className="text-gray-700" data-id="element-7487">
                      Diesel Exhaust & Performance
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-7488">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7489" />
                    <span className="text-gray-700" data-id="element-7490">Installation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7491">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7492">
              Certified Trailer Repair Services
            </h2>
            <p className="text-xl mb-6" data-id="element-7493">
              Licensed mechanics ensuring safety and reliability
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7494">
              <Phone className="mr-3" size={24} data-id="element-7495" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7496">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}